// Has what's on screen changed since it was saved? A blank site and the business's only site
// are the same thing (the site picker fills the one in), and a setting put back to nothing
// (null) is the same as one never set, so neither counts as a change.
export function changedSinceSaved(saved, current, sites = []) {
  const only = sites.length === 1 ? sites[0].id : null;
  const plain = (x) => JSON.stringify(x, (k, v) => (
    (k === 'site' && (!v || v === only)) || (k && v === null) ? undefined : v));
  return plain(saved) !== plain(current);
}
